module.exports = __webpack_public_path__ + "img/ys4.747b2635.png";